<template>
  <v-container>
      <v-layout row justify-center>
        <v-flex xs12 sm8 md8>
          <v-alert type="success" v-if="success"> You successfully updated {{River}} River Report  <v-btn text v-on:click="success=false"><v-icon class="font-weight-light">close</v-icon></v-btn></v-alert>
          <v-card class="ma-4" raised>
            <v-form class="pa-4" outlined ref="form">
              <v-select label="Enter River Name" v-model="River" return-object :items="Rivers" item-text="name" item-value="id" outlined @input="getData()"> <!-- Holds the data in select because you can only choose one-->
              </v-select>
              <v-text-field id="Author" v-model.lazy="reportModel.Author" outlined placeholder="Enter Authors Name Here"></v-text-field>
              <v-textarea id="Report" v-model="reportModel.Report" outlined placeholder="Enter Report Here"></v-textarea>
              <v-textarea id="Flies" v-model="reportModel.Flies" outlined placeholder="Enter Flies Here"></v-textarea>
              <v-btn block dark class="blue-grey darken-3" v-on:click="update"> Update Report </v-btn>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>

</v-container>
</template>
<script>
import fb from '@/fb'
import _ from 'lodash';

export default
{
  data()
  {
    return{
      on: false,
      success: false,
      River: null,
      Rivers: [],
      outputted: "",
      reportsRef: fb.db.collection('RiverReports'),
      reportModel: {Author: "", Report: "", Flies: "", date: Date.parse(new Date())},
    }
  },
  methods:
  {
    async getData(){
      if (this.River) {
        const snapshot = await this.reportsRef.where('River', '==', this.River.name).get();
        this.reportModel.Author = snapshot.docs[0].data().Author;
        this.reportModel.Report = snapshot.docs[0].data().Report;
        this.reportModel.Flies = snapshot.docs[0].data().Flies;
      }
    },
    update: async function()
    {
      await fb.db.collection('RiverReportAlert').doc('i8X355R2AiKDIK5naIwj').set({...this.reportModel, river: this.River.name}, {merge: true});

      this.reportsRef.doc(this.River.id).update(this.reportModel).then(() => {
        console.log("Updated DB");
        this.success = true;
      })
      this.$refs.form.reset();
    },    
  },
  async created()
  {
    await this.reportsRef.get().then((snapshot) =>
    {
      snapshot.docs.forEach((doc) => {
        this.Rivers.push({id: doc.id, name: doc.data().River})
      })
    })
    this.Rivers = _.sortBy(this.Rivers, [(river) => { return river.name}])
  }
}
</script>
<style scoped>
.flies
{
  width: 250px;
}
.size
{
  width: 75px;
}
</style>
